import U from '../js/utils';

export default async (elID, ddData, valueDataName, textDataName, onchange, placeholder) => {
  return new Promise(async (resolve, reject) => {
    try {
      let placeholderMsg = placeholder || '';
      const opts = await U.buildOptsDD(ddData, valueDataName, textDataName, placeholderMsg);

      const div = `
        <div id="${elID}Div" class="input-group">
          <select id="${elID}" name="${elID}" ${onchange ? `onchange="selectTheadChange('${onchange.replace(/'/g, "\\'")}')"` : ''}>
            ${opts}
          </select>
        </div>
      `;

      const element = U.createHTMLElementFromString(div);
      resolve(element);
    } catch (error) {
      reject(error);
    }
  });
};
